import React from 'react'
import { Link } from 'react-router-dom'

const EventCard = ({ event }) => {
    const startsAt = event.startsAt ? new Date(event.startsAt) : null
    const dateLabel = startsAt ? startsAt.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : ''
    const timeLabel = startsAt ? startsAt.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }) : ''
    const monthShort = startsAt ? startsAt.toLocaleDateString(undefined, { month: 'short' }) : ''
    const dayNum = startsAt ? startsAt.getDate() : ''
    const price = event.minPrice || event.price || event.ticketPrice || 0

    return (
        <div className="group relative bg-white rounded-3xl border border-slate-200 shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden flex flex-col h-full hover:-translate-y-1">
            {/* Gradient overlay on hover */}
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-10"></div>
            
            <Link to={`/events/${event._id || event.id}`} className="block relative h-56 overflow-hidden bg-gradient-to-br from-slate-100 to-slate-50">
                {event.coverImage ? (
                    <img
                        src={event.coverImage}
                        alt={event.title}
                        className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                ) : (
                    <div className="h-full w-full flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-50 text-slate-300">
                        <svg className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </div>
                )}
                
                {/* Date Badge */}
                {startsAt && (
                    <div className="absolute top-4 left-4 bg-white rounded-xl shadow-lg overflow-hidden">
                        <div className="bg-gradient-to-r from-cyan-600 to-blue-600 text-white text-xs font-bold px-3 py-1 text-center">
                            {monthShort.toUpperCase()}
                        </div>
                        <div className="px-3 py-2 text-center">
                            <div className="text-2xl font-extrabold text-slate-900">{dayNum}</div>
                        </div>
                    </div>
                )}
                
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </Link>

            <div className="relative p-6 flex-1 flex flex-col">
                {/* Time */}
                {timeLabel && (
                    <div className="flex items-center gap-2 text-sm font-semibold text-cyan-600 mb-3">
                        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span>{timeLabel}</span>
                    </div>
                )}

                {/* Title */}
                <Link to={`/events/${event._id || event.id}`} className="block mb-3">
                    <h3 className="text-xl font-extrabold text-slate-900 leading-tight line-clamp-2 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-cyan-600 group-hover:to-blue-600 transition-all duration-300">
                        {event.title}
                    </h3>
                </Link>

                {/* Description */}
                <p className="text-sm text-slate-600 line-clamp-2 mb-5 flex-1 leading-relaxed">
                    {event.description}
                </p>

                {/* Footer */}
                <div className="flex items-center justify-between mt-auto pt-5 border-t border-slate-100">
                    <span className="flex items-center gap-2 text-sm text-slate-600 font-semibold">
                        <svg className="h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span className="truncate max-w-[120px]">{event.venue || event.location || 'Online'}</span>
                    </span>

                    <Link
                        to={`/events/${event._id || event.id}`}
                        className="relative group/btn text-sm font-bold bg-gradient-to-r from-cyan-600 to-blue-600 text-white px-5 py-2.5 rounded-xl hover:from-cyan-500 hover:to-blue-500 transition-all shadow-lg shadow-cyan-500/30 hover:shadow-xl hover:shadow-cyan-500/40 hover:scale-105 active:scale-95 overflow-hidden whitespace-nowrap"
                    >
                        <span className="relative z-10">Get Tickets</span>
                        <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-blue-400 opacity-0 group-hover/btn:opacity-100 transition-opacity"></div>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default EventCard
